import { NgModule } from '@angular/core'
import { DataHomeMapComponent } from '@components/data-home-map/data-home-map.component'

@NgModule({
  imports: [],
  exports: [DataHomeMapComponent],
  declarations: [DataHomeMapComponent],
})
export class DataHomeMapModule {}
